/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useState, useRef, useContext } from 'react';
import Select from 'react-select';
import Chip from '@material-ui/core/Chip';
import { TextField, Grid, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import AddIcon from '@material-ui/icons/Add';
import FlashContext from '../../components/contexts/FlashContext';
import MyButton from '../../components/button/MyButton';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    listStyle: 'none',
    padding: 10,
    margin: 0,
  },
  chip: {
    margin: 10,
  },
  input: {
    backgroundColor: '#fff',
    marginTop: 0,
  },
}));

function Filter({ chipData, setChipData, find, setPage, setOpenDialog }) {
  const classes = useStyles();
  const { notifyError } = useContext(FlashContext);

  const searchRef = useRef(null);
  const [searchType, setSearchType] = useState(null);

  const [options, setOptions] = useState([
    { label: 'Nome', value: 'name' },
  ]);

  const handleDelete = chipToDelete => () => {
    setOptions([...options, { label: chipToDelete.by, value: chipToDelete.byType }]);
    setChipData(chips => chips.filter(chip => chip.key !== chipToDelete.key));
  };

  const internSearch = () => {
    setPage(0);
    const inputValue = searchRef?.current?.value?.trim();
    if (searchType && inputValue !== '') {
      includeSearch(true);
    } else {
      find();
    }
  };

  const includeSearch = btn => {
    try {
      if (!searchType) {
        notifyError('Escolha um tipo de filtro');
        return;
      }

      const inputValue = searchRef?.current?.value?.trim();

      if (!inputValue) {
        notifyError('Insira um valor para o filtro');
        return;
      }

      const newChip = {
        key: new Date().getTime(),
        label: inputValue,
        by: searchType.label,
        byType: searchType.value,
      };

      const newChipList = [...chipData, newChip];
      setChipData(newChipList);

      const newOptions = options.filter(e => e.value !== searchType.value);
      setOptions(newOptions);

      setSearchType(null);
      if (searchRef?.current) {
        searchRef.current.value = '';
      }

      if (btn) {
        find(newChipList);
      }
    } catch (e) {
      notifyError('Escolha um tipo');
    }
  };

  const addChip = () => {
    if (searchType) {
      includeSearch(false);
    } else {
      notifyError('Escolha um tipo de filtro');
    }
  };

  const teclaEnter = e => {
    if (e.key === 'Enter') internSearch();
  };

  return (
    <>
      <Grid container alignItems="center" style={{ marginBottom: 30, marginTop: 15 }}>
        <Grid item xs={12} md={2}>
          <MyButton onClick={() => setOpenDialog(true)} label="Nova Categoria" />
        </Grid>

        <Grid item xs={12} md={10}>
          <Grid container spacing={2} direction="row" alignItems="center" justify="flex-end">
            <Grid item>
              <Grid container spacing={1} alignItems="center">
                <Grid item>
                  <Select
                    onChange={setSearchType}
                    value={searchType}
                    placeholder="Filtrar por..."
                    isSearchable={false}
                    options={options}
                    menuPortalTarget={document.body}
                    styles={{
                      control: base => ({ ...base, minWidth: 200, height: 40 }),
                    }}
                  />
                </Grid>
                <Grid item style={{ display: 'flex', alignItems: 'end' }}>
                  <TextField
                    onKeyUpCapture={teclaEnter}
                    inputRef={searchRef}
                    variant="outlined"
                    size="small"
                    style={{ minWidth: 250 }}
                    InputProps={{
                      className: classes.input,
                      style: { height: 36 },
                    }}
                  />
                  <Button
                    onClick={addChip}
                    variant="contained"
                    style={{ marginLeft: 5, height: 40 }}
                  >
                    <AddIcon />
                  </Button>
                </Grid>
              </Grid>
            </Grid>
            <Grid item>
              <Button onClick={internSearch} variant="contained" color="primary">
                Buscar
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <Grid item className={classes.root}>
          {chipData.map((dt, i) => (
            // eslint-disable-next-line react/no-array-index-key
            <li key={i}>
              <Chip
                label={`${dt.by} | ${dt.label}`}
                onDelete={handleDelete(dt)}
                className={classes.chip}
              />
            </li>
          ))}
        </Grid>
      </Grid>
    </>
  );
}

export default Filter;